import { Field } from 'formik';
import { forwardRef } from 'react';

import {
    fieldPropsWithBackendErrors,
    selectFirstErrors,
} from '@perpay-web/utils/formUtils';

export function withFieldServerErrors(Component) {
    const FieldServerErrorsWrapper = forwardRef(
        (
            {
                className = null,
                errors = null,
                label = '',
                name,
                validate = null,
                ...rest
            },
            ref,
        ) => (
            <Field name={name} validate={validate}>
                {(fieldProps) => {
                    const firstBackendErrors = selectFirstErrors(errors);
                    const joinedFieldProps = fieldPropsWithBackendErrors(
                        fieldProps,
                        firstBackendErrors,
                    );

                    return (
                        <Component
                            name={name}
                            ref={ref}
                            {...joinedFieldProps}
                            {...rest}
                            className={className}
                            label={label}
                        />
                    );
                }}
            </Field>
        ),
    );

    FieldServerErrorsWrapper.displayName = 'FieldServerErrorsWrapper';

    return FieldServerErrorsWrapper;
}
